<template>
    <div>
        <v-navigation-drawer v-model="localdrawer" app>
            <div class="pa-2 ma-2" align="center">
                <v-img width="100"
                    :src="($vuetify.theme.dark) ? require('../assets/white-logo.svg') : require('../assets/black-logo.svg')">
                </v-img>
            </div>
            <v-divider></v-divider>
            <v-list v-if="getAccount" dense>
                <v-list-item v-for="(draw, i) in draws" :key="i" :to="draw.route">
                    <v-list-item-icon>
                        <span class="counter"
                            :class="($vuetify.theme.dark) ? 'darkCounterBackground' : 'lightCounterBackground'"
                            v-if="draw.icon == 'mdi-bell' && getUnreadMessages">{{ getUnreadMessages.length }}</span>
                        <v-icon v-text="draw.icon"></v-icon>

                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ draw.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-list v-if="getAccount == null" dense>
                <v-list-item :to="'/Login'">
                    <v-list-item-icon>
                        <v-icon v-text="'mdi-login'"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Login</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <template v-slot:append v-if="getAccount != null">
                <v-list v-if="getAccount != null" dense :to="'/Login'">
                    <v-list-item v-on:click="logout">
                        <v-list-item-icon>
                            <v-icon v-text="'mdi-logout'"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Logout</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </template>
        </v-navigation-drawer>
    </div>
</template>

<script>



import RestResource from '../RestResource.js';
import { mapGetters, mapActions } from 'vuex';
const restResourceService = new RestResource();
export default {
    name: "SideDraw",
    components: {

    },
    props: {
        drawer: Boolean,
    },
    data: () => ({
        isLoggedInComp: false,
        localdrawer: false,
        defaultDraws: [{
            title: "Home",
            icon: "mdi-home",
            route: "/",
        },
        {
            title: "My Account",
            icon: "mdi-account",
            route: "/MyAccount",
        },
        {
            title: "All Transactions",
            icon: "mdi-cash-multiple",
            route: "/AllTransactions",
        },
        {
            title: "Gallery",
            icon: "mdi-camera-burst",
            route: "/gallery",
        },
        {
            title: "Settings",
            icon: "mdi-cog",
            route: "/Settings",
        },
        ],
        draws:[],
    }),
    computed: {
        isDark() {
            return (this.$vuetify.theme.dark)
                ? 'dark'
                : 'light'
        },
        ...mapGetters([
            'getAccount',
            'accountSettings',
            'getAccountBalance',
            'getIsLoadingAccountBalance',
            'getIsLoadingAccount',
            'getUnreadMessages'
        ]),
    },

    mounted: function () {
        this.setDrawerBoolean();
        this.draws = [...this.defaultDraws];
    },
    watch: {
        accountSettings: {
            handler() {
                this.checkSettingsEnabled();
            }
        },
        drawer: function () {
            this.localdrawer = this.drawer;
        },
        isLoggedIn: function () {
            this.isLoggedInComp = this.isLoggedIn;
        },
        localdrawer: function (newVal) {
            this.setDrawerOnLocalDrawerChange(newVal);
        }
    },
    methods: {
        ...mapActions([
            'fetchAccount',
            'fetchAccountBalance',
            'logoutFromApp',
        ]),
        async logout() {
            const isLogout = await restResourceService.getLogout();
            if (isLogout) {
                this.setIsLoggedIn(false);
                this.logoutFromApp();
                this.$router.push({ path: '/login' });
            }
        },
        checkSettingsEnabled() {
            this.draws = [];
            this.draws = [...this.defaultDraws];
            console.log("SETTINGS ENABLED", this.accountSettings)
            let notifications = {
                title: "Notifications ",
                icon: "mdi-bell",
                route: "/notifications",
            }
            let takePayment = {
                title: "Take Payment",
                icon: "mdi-barcode-scan",
                route: "/TakePayment",
            }
            let checkIn = {
                title: "Check In",
                icon: "mdi-airplane-check",
                route: "/checkIn",
            }

            //Reverse order to how they will end up 
            if (this.accountSettings.notifications && !this.draws.includes(notifications)) 
                this.draws.splice(3, 0, notifications);
        
            if (this.accountSettings.checkIn && !this.draws.includes(checkIn))
                this.draws.splice(3, 0, checkIn)

            if (this.accountSettings.takePayment && !this.draws.includes(takePayment))
                this.draws.splice(3, 0, takePayment)


        },
        setDrawerBoolean: function () {
            this.localdrawer = this.drawer;
        },
        setDrawerOnLocalDrawerChange: function (value) {
            this.$emit('drawer', value);
        },
        setIsLoggedIn: function (value) {
            this.$emit('isLoggedIn', value);
        },
        closeSideBar: function () {
            this.$emit('drawer', false);
        }
    },
}
</script>

<style scoped>
.navTitle {
    padding: 15px;
    padding-left: 45px;
    color: white;
    display: inline-block;
}

.navItem {
    color: white;
}

.v-navigation-drawer__border {
    border-style: none !important;
    border-color: var(--houseColor) !important;
}

.counter {
    position: absolute;
    margin-left: -14px;
    margin-top: -10px;
    background-color: red;
    color: #fff;
    padding: 1px 4px;
    font-size: 11px;
    z-index: 2;
    -webkit-border-radius: 10rem;
    -moz-border-radius: 10rem;
    -ms-border-radius: 10rem;
    -o-border-radius: 10rem;
    border-radius: 10rem;
}
</style>